import { Paper } from '@mui/material';
import styled from 'styled-components';

/**
 * The standard content card. Used across features, so it lives here rather than in whichever one
 * happened to define it first.
 */
export const StyledPaper = styled(Paper)`
  padding: 15px;
  margin-bottom: 15px;
`;

/** A card's heading line: the title on the left, whatever acts on the card on the right. */
export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* Both, so a card using either heading level sits flush with the top of its paper. */
  > h2,
  > h3 {
    margin-top: 0px;
  }
`;

/**
 * The page shell: a centred column the restaurant pages share, so navigating between them does not
 * shift the content edges. Width and stack rhythm only — `Main` supplies the page gutter on every
 * side, so padding here would just spend room twice.
 */
export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  text-align: left;
  max-width: 1440px;
  margin: 0 auto;
`;

/** The line of context under a page title — which restaurant, which address. */
export const PageMetaLine = styled.div`
  margin-top: 4px;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;
